import { useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { BiTrash } from "react-icons/bi";

import classNames from "classnames";

import { removeFromCart } from "../../../redux/cart";

import { isValidUrl } from "../../../helpers/isValidUrl";

import { NEW_ITEM_ACTION } from "../../../constants/global";

import QuantityControls from "../../QuantityControls/QuantityControls";
import AddItemModal from "../../ui/Modal/AddItemModal/AddItemModal";
import { PriceDiscount } from "../../ui/index";

import logo from "../../../assets/images/logo.png";

const CartItem = (props) => {
  const { item, index } = props;

  const [newItemModal, setNewItemModal] = useState({
    isVisible: false,
    itemToEditPosition: null,
  });

  const dispatch = useDispatch();
  const { selectedCar } = useSelector((state) => state.car);
  const { isTaxable } = useSelector((state) => state.order);

  const editItemClickedHandler = (index) => {
    setNewItemModal({ isVisible: true, itemToEditPosition: index });
  };

  const onCloseModal = () => {
    setNewItemModal({ isVisible: false, itemToEditPosition: null });
  };

  return (
    <>
      {newItemModal.isVisible && (
        <AddItemModal
          closeModal={onCloseModal}
          action={NEW_ITEM_ACTION.EDIT}
          itemPositionToEdit={index}
        />
      )}
      <div
        className={classNames(
          "px-4",
          "py-1",
          "border",
          "border-light-gray",
          "rounded-lg",
          {
            "border-red-400":
              (item.isMisMatch && selectedCar.carDetails?.id) ||
              (isTaxable && !item.id && !item.skuNameId),
          }
        )}
      >
        {item.isMisMatch && selectedCar.carDetails?.id && (
          <p className="text-red-500 font-bold text-center">
            هذه القطعة لا تتطابق مع السيارة المختارة
          </p>
        )}

        {isTaxable && !item.id && !item.skuNameId && (
          <p className="text-red-500 font-bold text-center">
            يجب اختيار اسم لهذه القطعة لأن الطلب بفاتورة ضريبية
            <button
              className="mr-2 p-1 text-sm rounded bg-green-600 text-white hover:bg-green-500"
              onClick={() => editItemClickedHandler(index)}
            >
              تعديل
            </button>
          </p>
        )}

        <div className="flex flex-col xl:flex-row">
          <div className="w-full sm:w-1/5 mx-auto shrink-0 min-h-126 h-126 my-auto">
            <img
              src={
                isValidUrl(item.images[0]?.imageUrl)
                  ? item.images[0]?.imageUrl
                  : logo
              }
              alt={item.name}
              className="w-full h-full object-center object-contain"
            />
          </div>

          <div className="w-full md:w-4/5 mx-auto my-5 space-y-1 text-right pr-0 sm:pr-6">
            {item.brandName && (
              <p className="text-sm font-normal text-#677181">
                {item.brandName}
              </p>
            )}
            {item.id ? (
              <Link
                className="block text-lg font-normal hover:text-blue-400"
                to={`/product/${item.id}`}
              >
                {item.commercialName}
              </Link>
            ) : (
              <p className="block text-lg font-normal"> {item.name}</p>
            )}
            <div className="flex flex-wrap items-center gap-2">
              {item.id && (
                <p className="text-sm font-bold text-pink-900">ID: {item.id}</p>
              )}
              |
              <p className="text-sm font-bold text-pink-900">
                الكمية المتاحة : {item.availableQuantity || "-"}
              </p>{" "}
            </div>
            <div className="flex flex-wrap gap-2">
              <p>
                <span className="">سعر المخزن:</span>
                <span className="text-#216DA6 font-extrabold">
                  {" "}
                  {item.inventoryPrice || "-"}
                  {" جم"}
                </span>
              </p>
              |
              <p>
                <span className="">سعر السوق:</span>
                <span className="text-#216DA6 font-extrabold">
                  {" "}
                  {item.marketPrice || "-"}
                  {" جم"}
                </span>
              </p>
            </div>
            <p className="w-fit text-sm font-semibold text-#677181">
              <button
                className="flex items-center gap-2 text-red-400"
                onClick={() => dispatch(removeFromCart({ index }))}
              >
                <BiTrash />
                حذف
              </button>
            </p>

            {item.priceTierList && item.priceTierList.length > 0 && (
              <ul className="my-2 space-y-1 max-w-512 w-full mx-auto">
                {item.priceTierList.map((tier, index) => (
                  <li
                    key={index}
                    className="flex items-center gap-4 p-2 border border-slate-400 rounded-md bg-slate-100 drop-shadow-sm"
                  >
                    <p className="px-2 bg-slate-200 font-extrabold border border-slate-400 text-sm">
                      الكمية{" "}
                      <span className="font-extrabold text-blue-1">
                        {tier.quantity}
                      </span>
                      {" | "}
                      سعر القطعة{" "}
                      <span className="font-extrabold text-blue-1">
                        {tier.price}
                      </span>
                      {tier.id && " | Tier"}
                    </p>

                    {tier.id && tier.count && (
                      <span className="bg-gray-300 p-1 rounded-full text-xs font-bold">
                        x{tier.count}
                      </span>
                    )}

                    <PriceDiscount
                      oldPrice={
                        tier.id
                          ? (tier.count || 1) *
                            tier.quantity *
                            item.inventoryPrice
                          : null
                      }
                      newPrice={
                        (tier.id
                          ? (tier.count || 1) * tier.quantity
                          : tier.quantity) * tier.price
                      }
                      className="mr-auto"
                    />
                  </li>
                ))}
              </ul>
            )}
          </div>

          <div className="w-1/5 mx-auto my-5 min-w-144">
            <QuantityControls product={item} index={index} />
          </div>
        </div>
      </div>
    </>
  );
};

export default CartItem;
